<template>
    <div class="module-nav" :class="{ 'fixed-top': !isHome }">
        <ConfigNav class="config-style" />
        <Nav></Nav>
        <img style="cursor: pointer;height: 35px;position: absolute;top: 23px;left: 1%;" @click="goHome()" src="../NavWrap/images/logo.png" v-if="windowWidth > 769 && windowWidth <= 1046" alt="">
        <img style="cursor: pointer;height:30px" @click="goHome()" src="./images/logo.png" v-if="windowWidth < 769"
            alt="">
    </div>
</template>

<script>
import ConfigNav from "../ConfigNav"
import Nav from "../Nav"
export default {
    components: { ConfigNav, Nav },
    computed: {
        isHome() {
            return this.$route.path === '/'
        },
        navHeight() {
            return this.windowWidth < 769 ? '64px' : '88px'
        }
    },
    methods: {

        goHome() {
            if (this.$route.path !== '/') {
                this.$router.push('/').catch(() => {})
            }
        },
        updateBodyPadding() {
            if (!this.isHome) {
                document.body.style.paddingTop = this.navHeight
            } else {
                document.body.style.paddingTop = ''
            }
        }
    },
    watch: {
        isHome: {
            immediate: true,
            handler() {
                this.updateBodyPadding()
            }
        },
        windowWidth: {
            handler() {
                this.updateBodyPadding()
            }
        }
    },
}
</script>

<style lang="less" scoped>
.module-nav {
    position: relative;

    img {
        cursor: pointer;
        height: 30px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 34px;
    }
}

.fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

@media screen and (min-width: 770px) and (max-width: 1000px) {
    // .module-nav {

    //     img {
    //         height: 40% !important;
    //         top: 12px;
    //         left: 8px;
    //     }
    // }
}

@media screen and (min-width: 1000px) and (max-width: 1500px) {
    // .module-nav {

    //     img {
    //         height: 50% !important;
    //         top: 12px;
    //         left: 8px;
    //     }
    // }
}

@media screen and (max-width: 769px) {
    // .module-nav {

    //     img {
    //         height: 69% !important;
    //         top: 12px;
    //         left: 8px;
    //     }
    // }

    .config-style {
        display: none;
    }
}
</style>